<script setup lang="ts">
import docFile from "@/assets/icons/doc-file.svg";
import GradientIconButton from "@/components/buttons/GradientIconButton.vue";
import { defineProps, defineEmits } from "vue";

defineProps<{
  btnClasses: string | null;
  iconClasses?: string | null;
}>();

const emits = defineEmits(["click"]);
</script>

<template>
  <GradientIconButton
    :btnClasses="btnClasses"
    :iconClasses="iconClasses"
    :iconSrc="docFile"
    @click="emits('click')"
  />
</template>
